module.exports = __webpack_public_path__ + "8872fa9705c216bc9d813699b3203d52.jpg";